import React from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import Location from './components/Location';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import FloatingRocket from './components/FloatingRocket';
import StickyTextButton from './components/StickyTextButton';

function App() {
  return (
    <div className="App">
      <Header />
      <FloatingRocket />
      <StickyTextButton />
      <Hero />
      <About />
      <Menu />
      <Location />
      <ContactForm />
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;